export const FIND_COMPANY_REQUEST = "FIND_COMPANY_REQUEST";
export const FIND_COMPANY_SUCCESS = "FIND_COMPANY_SUCCESS";
export const FIND_COMPANY_FAILURE = "FIND_COMPANY_FAILURE";